// extracted by mini-css-extract-plugin
export default {"banner":"FamilyClinic_banner__EFqso","bannerCard":"FamilyClinic_bannerCard__mZq9h","department":"FamilyClinic_department__JWMrf"};